<zbp-button-component id="printToolButton"
                      type="button"
                      [ariaLabel]="'Print'"
                      label="Print"
                      [theme]="'viewerControl'"
                      [iconPosition]="'top'"
                      [customClass]="'viewer-asset-control-button'"
                      [iconName]="zbpIconNames.printer"
                      (click)="printImage()">
</zbp-button-component>
